import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { EventDetails } from '../modal/event';

export const getAllEventsAPI = async () => {
  const response = await baseAPI.get<Array<EventDetails>>(`/events/studio/all`);
  return response.data;
};

export const useGetAllEvents = () => {
  return useQuery({
    queryKey: [KEYS.EVENTS],
    queryFn: () => getAllEventsAPI(),
  });
};
